export type { RegularToDirectPlanAdviceCardDisplay } from '../../types/adviceCards.types'
import type { EliteInsights } from '../../../../types/misc.types'
import { roundOffAndFormatNumberWithCurrency } from '../../../../utils/utils'
import type { AdviceCardStat, RegularToDirectPlanAdviceCardDisplay } from '../../types/adviceCards.types'

function formatFundCountValue(count: number): string {
  return `${count} ${count === 1 ? 'fund' : 'funds'}`
}

export function buildRegularToDirectPlanAdviceCardDisplay(
  eliteInsights: EliteInsights | null | undefined
): RegularToDirectPlanAdviceCardDisplay {
  if (!eliteInsights) {
    return { stats: [], insightTone: 'orange' }
  }

  const stats: AdviceCardStat[] = []
  const fundsCount = eliteInsights.regularToDirect?.fundsCount ?? 0
  const extraCommissions = eliteInsights.regularPlanAlert?.extraCommissions ?? 0

  if (fundsCount > 0) {
    stats.push({
      value: formatFundCountValue(fundsCount),
      label: fundsCount === 1 ? 'is regular' : 'are regular'
    })
  }

  if (extraCommissions > 0) {
    stats.push({
      value: roundOffAndFormatNumberWithCurrency(extraCommissions),
      label: 'paid in extra commissions'
    })
  }

  return { stats, insightTone: 'orange' }
}
